var React = require('react');

function TwitterIcon (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M26.5 3c-.96.4-2 .7-3.07.81A5.29 5.29 0 0025.78.9a10.56 10.56 0 01-3.39 1.28A5.31 5.31 0 0018.5.5a5.31 5.31 0 00-5.2 6.51A15.17 15.17 0 012.32 1.47a5.3 5.3 0 001.65 7.09 5.4 5.4 0 01-2.41-.68v.07a5.3 5.3 0 004.27 5.2 5.67 5.67 0 01-2.4.1 5.33 5.33 0 004.97 3.67 10.72 10.72 0 01-7.9 2.2 15.15 15.15 0 008.18 2.38c9.8 0 15.16-8.07 15.16-15.08l-.01-.69A11.44 11.44 0 0026.5 3z","fill":"#50606C"}));
}

TwitterIcon.defaultProps = {"viewBox":"0 0 27 22","fill":"none"};

module.exports = TwitterIcon;

TwitterIcon.default = TwitterIcon;
